import { sectionBBehaviors } from "./sectionBBehaviors";

const observationStatus = (section) => {

    if (section.completed_on) {
        return "Completed";
    } else if (section.submitted_on && !section.completed_on) {
        return "Submitted";
    } else if (section.observed_on && !section.submitted_on && !section.completed_on) {
        return "In Progress";
    } else {
        return "Not Started";
    }
}

const inProgressObservation = (sections) => {
    const inProgress = sections.filter((cur)=>{
        return observationStatus(cur) === "In Progress";
    });

    return (inProgress.length === 1) ? inProgress[0] : null;
};

/*
const sectionInProgress = (sections) => {
    const inProgress = sections.filter((cur)=>{
        return observationStatus(cur) === "In Progress";
    });
    return (inProgress.length > 0) ? true : false;
}
*/

const overallSectionStatus = (sections) => {
    const allCompleted = sections.filter((cur)=>{
        return cur.completed_on;
    });
    if (allCompleted.length === sections.length && sections.length > 0) return "Completed";

    const submitted = sections.filter((cur)=>{
        return cur.submitted_on;
    });

    if (submitted.length === sections.length && sections.length > 0) return "All Submitted";


    const inProgress = sections.filter((cur)=>{
        return cur.observed_on;
    });
    if (inProgress.length > 0) return "In Progress";


    return "Not Started";
}

const finalEvaluationStatus = (finalEvaluation) => {

    if (finalEvaluation && 'completed_on' in finalEvaluation && finalEvaluation['completed_on']) {
        return "Completed";
    } else if (finalEvaluation) {
        return "In Progress";
    } else {
        return "Not Started";
    }
}


const booleanToInt=(input)=>{
    return (input) ? 1 : 0;
}

const intToBoolean=(input)=>{
    return (input === 1) ? true : false;
}

const round1 = (value) => Math.round(value * 10) / 10;

const averageAdjectiveComposite = (records, adjectives) => {
    if (!records.length || !adjectives.length) return 0;
    const totalSum = records.reduce((acc, record) => {
        const adjectiveSum = adjectives.reduce((sum, key) => sum + (record[key] || 0), 0);
        return acc + adjectiveSum;
    }, 0);
    const denominator = records.length * adjectives.length;
    return round1(denominator ? totalSum / denominator : 0);
};

const behaviorPresenceScore = (records, keys) => {
    if (!records.length) return 0;
    const scored = records.filter((record) => {
        const behaviors = record.behaviors || [];
        return behaviors.some((behavior) => keys.includes(behavior.behavior));
    });
    return round1((scored.length / records.length) * 10);
};

const inverseScore = (score) => round1(10 - score);

const countSectionBBehavior = (behaviors = [], behaviorKey = '') => {
    if (!Array.isArray(behaviors) || !behaviorKey) return 0;
    return behaviors.filter((record)=>{
        return record?.behavior === behaviorKey;
    }).length;
};

const sectionBBehaviorFrequencyPercents = (sectionBRecords = []) => {
    const behaviorKeys = sectionBBehaviors.map((behavior) => behavior.behaviorKey);
    const behaviorKeySet = new Set(behaviorKeys);
    const behaviors = behaviorKeys.reduce((acc, key) => {
        acc[key] = {
            count: 0,
            percent: 0,
        };
        return acc;
    }, {});

    const allBehaviors = sectionBRecords.flatMap((record) => {
        if (!Array.isArray(record?.behaviors)) return [];
        return record.behaviors;
    });
    const recognizedBehaviors = allBehaviors.filter((record) => behaviorKeySet.has(record?.behavior));
    const totalCount = recognizedBehaviors.length;

    recognizedBehaviors.forEach((record) => {
        behaviors[record.behavior].count += 1;
    });

    Object.keys(behaviors).forEach((key) => {
        behaviors[key].percent = totalCount ? round1((behaviors[key].count / totalCount) * 100) : 0;
    });

    return {
        totalCount,
        behaviors,
    };
};

export {
    observationStatus,
    overallSectionStatus,
    inProgressObservation,
    booleanToInt,
    intToBoolean,
    finalEvaluationStatus,
    round1,
    averageAdjectiveComposite,
    behaviorPresenceScore,
    inverseScore,
    countSectionBBehavior,
    sectionBBehaviorFrequencyPercents,
};
